import { MARKETING_MATERIAL_TYPE } from '../../constants';
import {
  ALBUM_SUBTYPE,
  ALBUM_TYPE,
} from '../../../../../../../constants/albums';
import { EVENT_SETTING_ANNIVERSARY } from '../../../../../../../constants/album-folder';
import { isWeddingsContent } from '../../../../../../../util/album';

export const availableMarketingMaterialTypesByType = {
  [ALBUM_TYPE.EVENT]: {
    [ALBUM_SUBTYPE.WEDDINGS]: [
      MARKETING_MATERIAL_TYPE.WEDDING_FLYER,
      MARKETING_MATERIAL_TYPE.WEDDING_TABLE_TENT,
      MARKETING_MATERIAL_TYPE.WEDDING_FLYER_VIDEO_GUESTBOOK,
    ],
    default: [
      MARKETING_MATERIAL_TYPE.EVENT_FLYER,
      MARKETING_MATERIAL_TYPE.EVENT_TABLE_TENT,
    ],
  },
  [ALBUM_TYPE.SHUTTERBUG]: [
    MARKETING_MATERIAL_TYPE.SHUTTERBUG_FLYER,
    MARKETING_MATERIAL_TYPE.SHUTTERBUG_TABLE_TENT,
  ],
  default: [
    MARKETING_MATERIAL_TYPE.ONBOARDING_FLYER,
    MARKETING_MATERIAL_TYPE.ONBOARDING_SOCIAL,
    MARKETING_MATERIAL_TYPE.PROFILE_PAGE_SOCIAL,
  ],
};

export const getAvailableMarketingMaterialTypes = albumFolder => {
  if (albumFolder?.album_type) {
    if (albumFolder.album_type === ALBUM_TYPE.SHUTTERBUG) {
      return availableMarketingMaterialTypesByType[albumFolder.album_type];
    }

    if (isWeddingsContent(albumFolder)) {
      return availableMarketingMaterialTypesByType[albumFolder.album_type][
        albumFolder.album_subtype
      ];
    }

    if (albumFolder.album_type === ALBUM_TYPE.EVENT) {
      return availableMarketingMaterialTypesByType[albumFolder.album_type]
        .default;
    }
  }

  return availableMarketingMaterialTypesByType.default;
};

export const getEventSubtypeMarketingMaterialMetadata = albumFolder => {
  switch (albumFolder.album_subtype) {
    case ALBUM_SUBTYPE.BIRTHDAYS:
      return {
        preview:
          '/marketing-material/MARKETING_MATERIAL_BIRTHDAYS_FLYER_TEMPLATE_PREVIEW.png',
        template:
          '/marketing-material/MARKETING_MATERIAL_BIRTHDAYS_FLYER_TEMPLATE.png',
      };
    case ALBUM_SUBTYPE.GRADUATIONS:
      return {
        preview:
          '/marketing-material/MARKETING_MATERIAL_GRADUATIONS_FLYER_TEMPLATE_PREVIEW.png',
        template:
          '/marketing-material/MARKETING_MATERIAL_GRADUATIONS_FLYER_TEMPLATE.png',
      };
    case ALBUM_SUBTYPE.MEMORIALS:
      return {
        preview:
          '/marketing-material/MARKETING_MATERIAL_MEMORIALS_FLYER_TEMPLATE_PREVIEW.png',
        template:
          '/marketing-material/MARKETING_MATERIAL_MEMORIALS_FLYER_TEMPLATE.png',
      };
    case ALBUM_SUBTYPE.VACATIONS:
      return {
        preview:
          '/marketing-material/MARKETING_MATERIAL_VACATIONS_FLYER_TEMPLATE_PREVIEW.png',
        template:
          '/marketing-material/MARKETING_MATERIAL_VACATIONS_FLYER_TEMPLATE.png',
      };
    case ALBUM_SUBTYPE.FUNDRAISERS:
      return {
        preview:
          '/marketing-material/MARKETING_MATERIAL_FUNDRAISERS_FLYER_TEMPLATE_PREVIEW.png',
        template:
          '/marketing-material/MARKETING_MATERIAL_FUNDRAISERS_FLYER_TEMPLATE.png',
      };
    case ALBUM_SUBTYPE.ANNIVERSARIES:
      if (
        albumFolder.event_settings?.anniversary_type ===
        EVENT_SETTING_ANNIVERSARY.WEDDING
      ) {
        return {
          preview:
            '/marketing-material/MARKETING_MATERIAL_ANNIVERSARIES_WEDDINGS_FLYER_TEMPLATE_PREVIEW.png',
          template:
            '/marketing-material/MARKETING_MATERIAL_ANNIVERSARIES_WEDDINGS_FLYER_TEMPLATE.png',
        };
      }

      return {
        preview:
          '/marketing-material/MARKETING_MATERIAL_ANNIVERSARIES_WORK_FLYER_TEMPLATE_PREVIEW.png',
        template:
          '/marketing-material/MARKETING_MATERIAL_ANNIVERSARIES_WORK_FLYER_TEMPLATE.png',
      };
    default:
      return {
        preview:
          '/marketing-material/MARKETING_MATERIAL_CUSTOM_EVENT_FLYER_TEMPLATE_PREVIEW.png',
        template:
          '/marketing-material/MARKETING_MATERIAL_CUSTOM_EVENT_FLYER_TEMPLATE.png',
      };
  }
};
